import { render, staticRenderFns } from "./HelpView.vue?vue&type=template&id=3b81af39&scoped=true"
import script from "./HelpView.vue?vue&type=script&lang=js"
export * from "./HelpView.vue?vue&type=script&lang=js"
import style0 from "./HelpView.vue?vue&type=style&index=0&id=3b81af39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b81af39",
  null
  
)

export default component.exports